import React, { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";

export const ReadyToPrint = ({ Component, print, name }) => {
  const componentRef = useRef(null);

  const handlePrint = useReactToPrint({
    documentTitle: name,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (print) {
      print.current = () => {
        handlePrint(() => componentRef.current);
      };
    }
  }, [handlePrint, print]);

  return <div ref={componentRef}>{Component}</div>;
};
